import { Component, OnInit } from '@angular/core';

import { MediaService } from 'src/app/services/media/media.service';
import { OwlOptions } from 'ngx-owl-carousel-o';
import 'owl.carousel';
declare var $: any;
@Component({
  selector: 'app-media',
  templateUrl: './media.component.html',
  styleUrls: ['./media.component.scss']
})
export class MediaComponent implements OnInit {

  imgList: any[];
  media: any[] = [];
  mediaString = '';

  customOptions: OwlOptions = {
    loop: true,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: false,
    dots: false, // Changed from true to false
    navSpeed: 700,
    navText: ['<i class="fas fa-chevron-left"></i>', '<i class="fas fa-chevron-right"></i>'],
    responsive: {
      0: { items: 1 },
      768: { items: 2 },
      992: { items: 3 }
    },
    nav: false
  };

  constructor(private service: MediaService) { }

  ngOnInit(): void {
    this.service.getMediaList();
    this.service.mediaList.snapshotChanges().subscribe(
      list => {
        this.imgList = list.map(item => { return item.payload.val(); });
        this.imgList = this.imgList.reverse();
        // Send all media items to the carousel instead of limiting to 4
        this.media = this.imgList;
      }
    );
  }
}